module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "default__bg"
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('sk-panel', [(_vm.loading) ? _c('div', {
    staticClass: "loading"
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "100",
      "width": 2,
      "primary": ""
    }
  })], 1) : _c('div', {
    staticClass: "booking-successful"
  }, [_c('sk-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "check-ticket"
  }, [_c('sk-title-heading', {
    attrs: {
      "h2": "",
      "label": "See you at the movies!"
    }
  }, [_c('template', {
    slot: "append"
  }, [_c('a', {
    attrs: {
      "href": _vm.pdfUrl,
      "target": "_blank"
    }
  }, [_c('sk-button', {
    staticClass: "no-print",
    attrs: {
      "secondary": "",
      "small": "",
      "loading": _vm.generateLoader
    }
  }, [_vm._v("Download\n                                            "), _c('template', {
    slot: "loader"
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "20",
      "width": 2
    }
  })], 1)], 2)], 1)])], 2), _vm._v(" "), _c('sk-layout', {
    staticClass: "covid-messaging",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-panel', [_c('p', {
    staticClass: "covid-headline"
  }, [_vm._v("\n                                       Thanks for booking with us! We've missed you and look forward to providing a safe cinematic experience!\n                                    ")])])], 1), _vm._v(" "), (!_vm.booking || _vm.booking.length <= 0) ? [_c('sk-panel', [_vm._v("\n                                    Sorry! We cant seem to find that booking. please contact Customer Care on: 0861 MOVIES (668437) for assistance.\n                                    "), _c('hr'), _vm._v("\n                                    your booking number is: " + _vm._s(_vm.$route.params.booking_number) + "\n                                    and your booking Id is: " + _vm._s(_vm.$route.params.booking_id) + "\n\n                                ")])] : _c('sk-booking', {
    attrs: {
      "bookingHistory": _vm.booking,
      "show-view": false,
      "show-download": false,
      "is-single-booking": true
    }
  })], 2)])], 1)], 1)]), _vm._v(" "), (!_vm.loading) ? [_c('sk-signin', {
    staticClass: "no-print"
  }), _vm._v(" "), _c('sk-related-movies', {
    staticClass: "no-print",
    attrs: {
      "movies": _vm.related_movies,
      "limit": "6"
    }
  })] : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-053ca791","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/booking/booking-successful/booking-succesful.vue
// module id = 752
// module chunks = 0